import styled from 'styled-components';

const Wrapper = styled.div`
  .search-box {
    display: flex;
    align-items: center;
    padding: 4px 8px;
    background: ${(props) => props.theme.colors.widget_background};
    border-radius: 100px;
    border: 1px solid transparent;
    transition: all .2s ease-in;

    &:hover {
      background: ${(props) => props.theme.colors.main_cta_light};
      color: ${(props) => props.theme.colors.main_cta};
    }

    .input-search {
      width: 0;
      color: ${(props) => props.theme.colors.inactive};
      transition: all .3s ease-out;
    }

    .btn-search {
      width: 16px;
      height: 16px;

      .icon {
        width: 100%;
        height: 100%;
      }
      cursor: pointer;
    }

    &.open {
      gap: 8px;
      background: ${(props) => props.theme.colors.main_cta_light};
      border-color: ${(props) => props.theme.colors.main_cta};

      .input-search {
        width: 100px;
      }

      .btn-search {
        color: ${(props) => props.theme.colors.main_cta};
      }
    }
  }
`;

export default { Wrapper };
